import { inject } from '@angular/core';
import { provideAppInitializer } from '@angular/core';
import { PluginRegistryService } from '@brighthub/plugin';
import { MenuKey, MenuStore } from '@brighthub/shell/data-access-menu';
import { environment } from '@brighthub/environment';

export function provideBrightaiPlugin() {
  return [
    provideAppInitializer(() => {
      const registry = inject(PluginRegistryService);
      registry.registerPlugin(() => {
        const menuStore = inject(MenuStore);
        menuStore.register({
          id: 'myclients',
          label: 'My Clients',
          icon: 'pi-home',
          menuKey: MenuKey.MAIN,
          route: '/brightai/myclients',
          order: 1,
        });
        menuStore.register({
          id: 'searchedConversations',
          label: 'Searched Convos',
          icon: 'pi-list',
          menuKey: MenuKey.MAIN,
          route: '/brightai/conversation',
          order: 2,
          groups: [`BrightAI_${environment.environment}_admin`]
        });
        menuStore.register({
          id: 'employeeConversation',
          label: 'Employee Conversation',
          icon: 'pi-user',
          menuKey: MenuKey.MAIN,
          route: '/brightai/employee',
          order: 3,
          groups: [`BrightAI_${environment.environment}_admin`]
        });
      });
    }),
  ];
}
